import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    HostListener,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import * as mySettings from '../../../settings';
import {LogicheckCaseService} from '../../services/logicheck-case.service';
import {ClientCaseId} from '../../domain/client-case-id';
import * as _ from 'lodash';
import {Tooltip} from '../../domain/tooltip';


@Component({
    selector: 'app-case-id',
    templateUrl: './case-id.component.html',
    styleUrls: ['./case-id.component.scss']
})
export class CaseIdComponent implements OnInit, OnDestroy, OnChanges {
    @Input() partialCaseActivated: boolean;
    @Input() tooltips: Tooltip[];

    public model: any;
    public partialCaseEnabled: boolean;
    public isPartialCase: boolean;
    public clientCaseId: ClientCaseId;
    public errors: any = {};
    private mainSeparator: string;
    private partialSeparator: string;
    private mainPartialSeparator: string;
    private onCaseIdChange: any;
    private subscriptions = [];
    private enablePadding: boolean;

    public showTooltip = false;

    @Output() clientCaseIdChange = new EventEmitter();
    public tooltipText: any;

    constructor(private logicheckCaseService: LogicheckCaseService, private cd: ChangeDetectorRef) {
    }


    ngOnInit() {
        this.model = mySettings.CLIENT_CASE_ID_MODEL;
        this.enablePadding = mySettings.ENABLE_PADDING || false;
        this.partialCaseEnabled = mySettings.PARTIAL_CASE_ENABLED;
        this.mainSeparator = mySettings.CASE_ID_MAIN_SEPARATOR || ' ';
        this.partialSeparator = mySettings.CASE_ID_PARTIAL_SEPARATOR || ' ';
        this.mainPartialSeparator = mySettings.CASE_ID_MAIN_PARTIAL_SEPARATOR || ' ';
        this.partialCaseActivated = this.partialCaseActivated || false;
        this.clientCaseId = new ClientCaseId();

        this.subscriptions.push(this.logicheckCaseService.caseLoaded.subscribe(() => {
            if (sessionStorage.getItem('clientCaseIdString') != null) {
                this.parseClientCaseId(sessionStorage.getItem('clientCaseIdString').replace('+', ' '), false);
                this.initCaseId();
                sessionStorage.removeItem('clientCaseIdString');
            } else {
                this.clientCaseId = this.logicheckCaseService.currentCase.clientCaseId;
                this.initCaseId();
            }

        }));
        if (this.logicheckCaseService.currentCase) {
            this.clientCaseId = this.logicheckCaseService.currentCase.clientCaseId;
            this.initCaseId();
        }

        this.onCaseIdChange = this.model.onClientCaseIdChange;
        this.calculateMaxLength();
    }

    onResultChange(newValue: string, objectPart: string, index: number) {
        let oldMainId = '';
        if (this.clientCaseId.main !== undefined && this.clientCaseId.main !== null && this.clientCaseId.main.length > 0) {
            oldMainId = this.clientCaseId.main.join(this.mainSeparator || '');
        }
        this.clientCaseId[objectPart][index] = newValue;
        let isComplete = true;
        let isValid = true;
        let plain = '';
        this.errors = {};
        if (this.onCaseIdChange !== undefined) {
            this.onCaseIdChange(this.clientCaseId, this.model);
            this.cd.markForCheck();
        }

        this.model.idComponentsConfiguration.forEach((componentConfiguration, i) => {

            if (this.clientCaseId.main[i] && componentConfiguration[componentConfiguration.activeList] !== undefined &&
                componentConfiguration[componentConfiguration.activeList] !== '') {
                // is selected value in the list?
                const result = componentConfiguration[componentConfiguration.activeList].find(obj => {
                    return obj.value === this.clientCaseId.main[i];
                });
                if (result === undefined) {

                    this.clientCaseId.main[i] = '';
                }

            }
            if ((this.clientCaseId.main[i] === undefined
                    || this.clientCaseId.main[i] === null
                    || this.clientCaseId.main[i] === '') && componentConfiguration.activeList !== undefined &&
                componentConfiguration.activeList !== '') {
                const defaultOption = _.find(componentConfiguration[componentConfiguration.activeList], ['default', true]);

                if (defaultOption !== undefined) {
                    this.clientCaseId.main[i] = defaultOption.value;
                }
            }
            if (this.clientCaseId.main[i] !== '') {
                plain += i === this.model.idComponentsConfiguration.length - 1 ?
                    this.clientCaseId.main[i] : this.clientCaseId.main[i] + this.mainSeparator;
            }
            isComplete = isComplete && (!!this.clientCaseId.main[i]);
            let componentValid = (componentConfiguration.isValid && componentConfiguration.isValid(this.clientCaseId.main[i]));
            if (componentValid && componentConfiguration.restrict) {
                componentValid = this.validateRegexp(this.clientCaseId.main[i], componentConfiguration.restrict);
            }
            if (this.errors.main === undefined) {
                this.errors.main = {};
            }

            if (!componentValid) {
                this.errors.main[i] = 'Schadennr. ungültig';
            } else {
                this.errors.main[i] = undefined;
            }


            isValid = isValid && componentValid;


        });
        this.cd.detectChanges();
        /*if (this.onCaseIdChange !== undefined) {
            this.onCaseIdChange(this.clientCaseId, this.model);
            this.cd.markForCheck();
        }*/
        if (this.isPartialCase) {
            plain = plain + this.mainPartialSeparator;
            this.clientCaseId.plain = this.clientCaseId.plain + this.mainPartialSeparator;
            this.model.idPartialsConfiguration.forEach((componentConfiguration, i) => {

                isComplete = isComplete && this.clientCaseId.partial[i] !== undefined && this.clientCaseId.partial[i] !== null;
                if (this.clientCaseId.partial[i] !== '') {
                    plain += i === this.model.idPartialsConfiguration.length - 1 ?
                        this.clientCaseId.partial[i] : this.clientCaseId.partial[i] + this.partialSeparator;
                }

                isValid = isValid && (componentConfiguration.isValid ? componentConfiguration.isValid(this.clientCaseId.partial[i]) : true);
            });

            if (this.onCaseIdChange !== undefined) {
                this.onCaseIdChange(this.clientCaseId, this.model);
                this.cd.markForCheck();
            }
        }
        this.clientCaseId.plain = plain;
        let mainId: string;
        if (this.clientCaseId.main !== undefined && this.clientCaseId.main !== null && this.clientCaseId.main.length > 0) {
            mainId = this.clientCaseId.main.join(this.mainSeparator || '');
        }
        // if (mainId !== oldMainId) {
        this.clientCaseIdChange.emit({caseId: this.clientCaseId, isValid: isValid, isComplete: isComplete});
        // }
        this.cd.markForCheck();

    }


    updateIsPartialCase($event: boolean) {
        this.isPartialCase = $event;
        if (!$event) {
            this.clientCaseId.partial = [];
        }
    }

    @HostListener('copy', ['$event']) onCopy(event?: any) {
        const clipboard = event.clipboardData || window['clipboardData'];
        clipboard.setData('text', this.clientCaseId.plain);
        event.preventDefault();
    }

    @HostListener('paste', ['$event']) onPaste(event: any) {
        event.preventDefault();
        let data = '';
        if (typeof event.clipboardData === 'undefined') {
            data = window['clipboardData'].getData('Text');
        } else {
            data = event.clipboardData.getData('text/plain');
        }
        data = data.trim();
        let parsed = false;
        if (event.target && event.target.id) {
            const idArr = event.target.id.split('.');
            if (idArr.length > 1) {
                let conf: any = '';
                const index = parseInt(idArr[1], 10);
                if (idArr[0] === 'main') {
                    conf = this.model.idComponentsConfiguration[index];
                } else {
                    conf = this.model.idPartialsConfiguration[index];
                }
                if (data.length <= conf.requiredLength) {
                    this.clientCaseId[idArr[0]][index] = data;
                    if (data.length === conf.requiredLength) {
                        parsed = true;
                    }
                    this.cd.markForCheck();
                    this.onResultChange(data, idArr[0], index);
                }
            }
        }
        if (!parsed) {
            this.parseClientCaseId(data, true);
        }

    }


    private parseClientCaseId(data: string, pad: boolean) {
        if (data !== undefined && data !== null && data !== '') {
            const mainLength = this.model.idComponentsConfiguration.length;
            const partLength = this.model.idPartialsConfiguration.length;
            let parts = 0;
            while (parts < mainLength) {
                let separator = this.mainSeparator;
                let pos = -1;
                if (this.model.idComponentsConfiguration[parts].span && this.model.idComponentsConfiguration[parts].span > 1) {
                    if (parts === mainLength - 1 && this.mainSeparator !== this.mainPartialSeparator) {
                        separator = this.mainPartialSeparator;
                        pos = data.indexOf(separator);
                    } else {
                        pos = this.nthIndex(data, separator, this.model.idComponentsConfiguration[parts].span + 1);
                    }
                } else {
                    separator = parts < mainLength - 1 ? this.mainSeparator : this.mainPartialSeparator;
                    pos = data.indexOf(separator);
                }
                if (pos > -1) {
                    this.clientCaseId.main[parts] = data.substring(0, pos);
                    this.padData(pad, parts);
                    /*if (pad && this.enablePadding && this.model.idComponentsConfiguration[parts].padSettings !== null) {
                        if (this.clientCaseId.main[parts].length < this.model.idComponentsConfiguration[parts].requiredLength) {
                            if (this.model.idComponentsConfiguration[parts].padSettings.padDirection === 'left') {
                                this.clientCaseId.main[parts] =
                                    this.clientCaseId.main[parts].padStart(this.model.idComponentsConfiguration[parts].requiredLength,
                                        this.model.idComponentsConfiguration[parts].padSettings.padChar);
                            } else {
                                this.clientCaseId.main[parts] =
                                    this.clientCaseId.main[parts].padEnd(this.model.idComponentsConfiguration[parts].requiredLength,
                                        this.model.idComponentsConfiguration[parts].padSettings.padChar);
                            }

                        }
                    }*/
                    data = data.substring(pos + 1);
                } else {
                    this.clientCaseId.main[parts] = data;
                    this.padData(pad, parts);
                    data = '';
                }

                parts++;

                if (this.onCaseIdChange !== undefined) {
                    this.onCaseIdChange(this.clientCaseId, this.model);
                    this.cd.markForCheck();
                }

            }
            this.clientCaseId.plain = this.clientCaseId.main.join(this.mainSeparator);
            if (this.partialCaseEnabled && !this.isPartialCase && data.length > 0) {
                this.partialCaseEnabled = true;
                this.isPartialCase = true;
            }
            if (this.partialCaseEnabled && data.length > 0) {
                parts = 0;
                while (parts < partLength) {
                    if (parts === partLength - 1) {
                        this.clientCaseId.partial[parts] = data;
                    } else {

                        const pos1 = data.indexOf(this.partialSeparator);
                        this.clientCaseId.partial[parts] = data.substring(0, pos1);
                        data = data.substring(pos1 + 1);
                    }
                    parts++;
                }
                this.clientCaseId.plain = this.clientCaseId.plain + this.mainPartialSeparator +
                    this.clientCaseId.partial.join(this.partialSeparator);
            }
            this.cd.markForCheck();
            setTimeout(() => {
                this.onResultChange(this.clientCaseId.main[0], 'main', 0);
            });

        }
    }

    private padData(pad: boolean, index: number) {
        if (pad && this.enablePadding && this.model.idComponentsConfiguration[index].padSettings !== null) {
            if (this.clientCaseId.main[index].length > 0) {
                if (this.clientCaseId.main[index].length < this.model.idComponentsConfiguration[index].requiredLength) {
                    if (this.model.idComponentsConfiguration[index].padSettings.padDirection === 'left') {
                        this.clientCaseId.main[index] =
                            this.clientCaseId.main[index].padStart(this.model.idComponentsConfiguration[index].requiredLength,
                                this.model.idComponentsConfiguration[index].padSettings.padChar);
                    } else {
                        this.clientCaseId.main[index] =
                            this.clientCaseId.main[index].padEnd(this.model.idComponentsConfiguration[index].requiredLength,
                                this.model.idComponentsConfiguration[index].padSettings.padChar);
                    }

                }
            }
        }
    }

    private initCaseId() {
        if (this.onCaseIdChange !== undefined) {
            this.onCaseIdChange(this.clientCaseId, this.model);
            this.cd.markForCheck();
        }
        this.errors = {};
        this.isPartialCase = false;
        if (this.clientCaseId.main.length === 0) {
            this.clientCaseId.main = new Array(this.model.idComponentsConfiguration.length).fill(null);
        }
        if (this.clientCaseId.partial.length > 0 && this.clientCaseId.partial[0] !== null) {
            this.isPartialCase = true;
        }
        if (this.clientCaseId.partial.length === 0 && this.model.idPartialsConfiguration.length > 0) {
            this.clientCaseId.partial = new Array(this.model.idPartialsConfiguration.length).fill(null);
        }
        this.model.idComponentsConfiguration.forEach((componentConfiguration, i) => {
            if ((this.clientCaseId.main[i] === undefined
                    || this.clientCaseId.main[i] === null
                    || this.clientCaseId.main[i] === '') && componentConfiguration.activeList !== undefined &&
                componentConfiguration.activeList !== '') {
                const defaultOption = _.find(componentConfiguration[componentConfiguration.activeList], ['default', true]);

                if (defaultOption !== undefined) {
                    this.clientCaseId.main[i] = defaultOption.value;
                    this.clientCaseId.plain = defaultOption.value;
                }
            }
        });
    }

    ngOnDestroy():
        void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.tooltips && changes.tooltips.currentValue) {
            const tooltip = _.find(changes.tooltips.currentValue, ['name', 'PARTIAL_CASE_ID_TIP']);
            if (tooltip) {
                this.tooltipText = tooltip.content;
            }
            this.showTooltip = !!tooltip;
        }
    }

    private calculateMaxLength() {
        this.model.idComponentsConfiguration.forEach((componentConfiguration, i) => {
            if ((componentConfiguration.type === 'DROP_DOWN') && componentConfiguration.activeList !== undefined &&
                componentConfiguration.activeList !== '') {

                const max = this.findMax(componentConfiguration[componentConfiguration.activeList]);

                if (max !== undefined) {
                    this.model.idComponentsConfiguration[i].maxLength = max;
                }
            } else if ((componentConfiguration.type === 'DROP_DOWN') && componentConfiguration.options1 !== undefined &&
                componentConfiguration.options1 !== '') {
                const max = this.findMax(componentConfiguration.options1);

                if (max !== undefined) {
                    this.model.idComponentsConfiguration[i].maxLength = max;
                }
            }
        });
    }

    private findMax(optionList) {
        const longest = optionList.reduce(
            function (a, b) {
                return a.length > b.length ? a : b;
            }
        );
        return longest.value.length;
    }

    private validateRegexp(value: string, restrict: string) {
        const re = new RegExp('^' + restrict + '+$');
        return re.test(value);
    }

    private nthIndex(value: string, pattern: string, startPosition: number) {
        const length = value.length;
        let i = -1;
        while (startPosition-- && i++ < length) {
            i = value.indexOf(pattern, i);
            if (i < 0) {
                break;
            }
        }
        return i;
    }
}
